/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Auto_ControlInputs */



/**
* | output |
* | --- |
* | "Manual and automatic control" |
*
* @param {Manual_Auto_ControlInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_auto_control = /** @type {((inputs?: Manual_Auto_ControlInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Auto_ControlInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Manual and automatic control")
	return /** @type {LocalizedString} */ ("Contrôle manuel et automatique")
});